export default __webpack_public_path__ + "3bcde5227c0794ceef3d7ac9fc2c0d8b.jpeg";